// Central content, images and bilingual copy for Seven Home Services

export const CONTACT = {
  phoneDisplay: "(689) 246-5162",
  phoneHref: "tel:+16892465162",
  whatsapp: "https://wa.me/16892465162?text=Ol%C3%A1!%20Gostaria%20de%20um%20or%C3%A7amento%20gr%C3%A1tis.",
  email: "support@seven-homeservices.com",
  address: "Winter Garden, FL 34787 — USA",
};

// Standardized service dropdown options for the quote form
export const SERVICE_OPTIONS = [
  "Painting",
  "Drywall Repair",
  "Remodeling",
  "Flooring",
  "Gutters",
  "Pressure Washing",
  "Other",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1613621792067-8e28d16b735c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  manifesto: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ctaBg: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  gallery: [
    {
      id: "exterior",
      before: "https://images.unsplash.com/photo-1591528287397-977d8a3d4d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      after: "https://images.unsplash.com/photo-1753977725475-41b221add2c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      cat: "reforma",
    },
    {
      id: "interior",
      before: "https://images.unsplash.com/photo-1768321902047-2296fd495fa4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      after: "https://images.unsplash.com/photo-1593696140826-c58b021acf8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      cat: "drywall",
    },
    {
      id: "kitchen",
      before: "https://images.unsplash.com/photo-1606383446421-d0f8bdd1e5b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      after: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      cat: "pintura",
    },
  ],
};

export const SERVICES = [
  {
    id: "pintura",
    icon: "PaintRoller",
    img: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "lg:col-span-2 lg:row-span-2",
    pt: { title: "Pintura impecável", desc: "Interiores e exteriores com acabamento premium e tintas de longa duração." },
    en: { title: "Flawless Painting", desc: "Interior & exterior with premium finish and long-lasting paints." },
  },
  {
    id: "reforma",
    icon: "Hammer",
    img: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Reforma completa", desc: "Do projeto à entrega, transformamos qualquer ambiente." },
    en: { title: "Full Remodeling", desc: "From design to delivery — we transform any space." },
  },
  {
    id: "drywall",
    icon: "LayoutPanelLeft",
    img: "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Drywall", desc: "Paredes e forros perfeitos, rápidos e sem sujeira." },
    en: { title: "Drywall", desc: "Perfect walls and ceilings — fast and clean." },
  },
  {
    id: "pisos",
    icon: "Grid3x3",
    img: "https://images.unsplash.com/photo-1523413307857-ef24c53571ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Pisos & Azulejos", desc: "Instalação precisa de porcelanato, laminado e cerâmica." },
    en: { title: "Floors & Tiles", desc: "Precise install of porcelain, laminate and ceramic." },
  },
  {
    id: "framing",
    icon: "Frame",
    img: "https://images.unsplash.com/photo-1768321902047-2296fd495fa4?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Estrutura (Framing)", desc: "Estruturas sólidas e seguras, dentro do código." },
    en: { title: "Framing", desc: "Solid, safe, code-compliant structures." },
  },
  {
    id: "gutter",
    icon: "Waves",
    img: "https://images.unsplash.com/photo-1591528287397-977d8a3d4d79?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Calhas (Gutter)", desc: "Instalação e proteção contra chuvas e infiltrações." },
    en: { title: "Gutters", desc: "Install & protection against rain and leaks." },
  },
  {
    id: "soffit",
    icon: "Home",
    img: "https://images.unsplash.com/photo-1753977725475-41b221add2c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "",
    pt: { title: "Soffit", desc: "Acabamento de beirais que valoriza e protege sua casa." },
    en: { title: "Soffit", desc: "Eave finishing that protects and elevates your home." },
  },
  {
    id: "pressure",
    icon: "Droplets",
    img: "https://images.unsplash.com/photo-1781637202423-33ec5b47e52e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    span: "lg:col-span-2",
    pt: { title: "Lavagem de alta pressão", desc: "Fachadas, calçadas e telhados como novos em poucas horas." },
    en: { title: "Pressure Washing", desc: "Facades, driveways and roofs like new in hours." },
  },
];

export const TESTIMONIALS = [
  { name: "Maria Fernandes", city: "Orlando, FL", pt: "Pintaram minha casa inteira em 3 dias. Ficou impecável e o preço foi justo!", en: "They painted my whole house in 3 days. Flawless and fair price!" },
  { name: "James Carter", city: "Kissimmee, FL", pt: "Equipe pontual, limpa e super profissional. Recomendo demais!", en: "Punctual, clean and super professional team. Highly recommend!" },
  { name: "Ana Souza", city: "Winter Park, FL", pt: "A reforma da cozinha superou todas as expectativas. Nota 10!", en: "Kitchen remodel exceeded all expectations. 10/10!" },
  { name: "David Nguyen", city: "Lake Nona, FL", pt: "Orçamento rápido e transparente. Entregaram no prazo.", en: "Fast, transparent quote. Delivered right on time." },
  { name: "Patrícia Lima", city: "Orlando, FL", pt: "O drywall ficou perfeito, sem sujeira nenhuma. Muito bom!", en: "Drywall came out perfect, zero mess. Amazing!" },
  { name: "Robert Miller", city: "Sanford, FL", pt: "Lavagem de alta pressão deixou a fachada como nova.", en: "Pressure washing made the facade look brand new." },
];

export const COPY = {
  pt: {
    nav: { services: "Serviços", gallery: "Galeria", why: "Diferenciais", reviews: "Avaliações", book: "Agendar", cta: "Orçamento Grátis" },
    hero: {
      badge: "Contratante Licenciado & Segurado · Winter Garden & Grande Orlando",
      l1: "Reparos e reformas",
      l2: "de alto padrão",
      l3: "no prazo e bem-feitos.",
      sub: "De pintura e drywall a reformas completas. Trabalho confiável e de alta qualidade, sem taxas escondidas e com 100% de satisfação garantida.",
      cta1: "Solicitar Orçamento Grátis",
      cta2: "Ligar (689) 246-5162",
      seals: ["Licenciado e Segurado", "Nota 4.9/5 · 500+ Projetos", "Resposta em 24h"],
    },
    proof: [
      { n: "500+", l: "Projetos concluídos" },
      { n: "100%", l: "Satisfação dos clientes" },
      { n: "12+", l: "Anos de experiência" },
      { n: "4.9★", l: "Avaliação média" },
    ],
    marquee: "TRABALHO GARANTIDO ✦ QUALIDADE PREMIUM ✦ ORÇAMENTO GRÁTIS ✦ ATENDIMENTO RÁPIDO ✦ LICENCIADOS ✦",
    services: { overline: "O que fazemos", title: "Serviços que vendem confiança", cta: "Solicitar orçamento" },
    gallery: { overline: "Antes & Depois", title: "Transformações reais em casas de Orlando", sub: "Arraste para comparar nossos trabalhos recentes em Pintura, Drywall e Reforma.", ctaText: "Gostou do que viu?", ctaBtn: "Solicite um orçamento parecido", filters: { all: "Todos", pintura: "Pintura", reforma: "Reforma", drywall: "Drywall" }, before: "ANTES", after: "DEPOIS" },
    why: {
      overline: "Por que a Seven Home",
      title: "Por que os moradores da Flórida Central confiam na Seven Home Services",
      items: [
        { t: "Preços claros e transparentes", d: "Sem custos-surpresa ou taxas escondidas. O que orçamos é o que você paga." },
        { t: "Licenciada e totalmente segurada", d: "Tranquilidade total sabendo que seu imóvel está 100% protegido." },
        { t: "Agendamento rápido e confiável", d: "Chegamos na hora, respeitamos sua agenda e terminamos no prazo." },
        { t: "Limpeza impecável", d: "Tratamos sua casa como a nossa. Zero sujeira deixada para trás." },
      ],
    },
    midcta: { title: "Pronto para transformar sua casa?", sub: "Peça seu orçamento grátis agora mesmo — vagas limitadas para esta semana.", cta1: "Solicitar orçamento", cta2: "Falar no WhatsApp" },
    guarantee: { overline: "Sem risco", title: "Nossa Garantia de 100% de Satisfação", body: "Só consideramos o trabalho concluído quando você estiver completamente satisfeito com o resultado. Se algo não estiver certo, corrigimos imediatamente — sem desculpas." },
    reviews: { overline: "Prova social", title: "O que os clientes dizem" },
    form: {
      overline: "Orçamento grátis",
      title: "Solicite seu orçamento grátis em 30 segundos",
      urgency: "⚡ Vagas limitadas na agenda desta semana.",
      name: "Nome completo", phone: "Telefone (obrigatório)", email: "Email", zip: "Zip Code (para verificar disponibilidade)", service: "Serviço desejado", selectService: "Serviço desejado", message: "Mensagem (opcional)",
      photo: "Anexar foto do local (opcional — orçamento até 2x mais rápido)", uploading: "Enviando foto...", photoError: "Falha ao enviar a foto.", remove: "Remover",
      submit: "QUERO MEU ORÇAMENTO GRÁTIS", sending: "Enviando...",
      success: "Recebemos seu pedido! Entraremos em contato em instantes.",
      error: "Ops, algo deu errado. Tente novamente ou chame no WhatsApp.",
      phoneReq: "Informe um telefone para contato.",
    },
    book: {
      overline: "Agendamento online",
      title: "Agende uma visita gratuita",
      date: "Data", time: "Horário", selectTime: "Escolha o horário",
      submit: "Confirmar agendamento", sending: "Agendando...",
      success: "Visita agendada! Confirmaremos por telefone.",
      step2Title: "Passo 2 (opcional): agende sua visita gratuita",
      step2Sub: "Escolha o melhor dia e horário para nossa equipe visitar.",
      skip: "Pular por agora",
      thanksTitle: "Tudo certo! 🎉",
      thanksSub: "Recebemos seus dados. Nossa equipe entrará em contato em instantes.",
    },
    footer: { tagline: "Profissionais licenciados e segurados.", quick: "Links rápidos", servicesTitle: "Serviços", contact: "Contato", rights: "Todos os direitos reservados." },
    chat: { title: "Fale com a gente", placeholder: "Escreva sua mensagem...", welcome: "Olá! 👋 Como podemos ajudar na sua casa hoje?", send: "Enviar" },
    exit: { title: "Espere! 🎁", sub: "Não vá embora sem seu orçamento grátis. Ganhe 10% de desconto agendando esta semana.", cta: "Quero meu desconto", dismiss: "Não, obrigado" },
    mobile: { call: "Ligar", quote: "Orçamento" },
  },
  en: {
    nav: { services: "Services", gallery: "Gallery", why: "Why Us", reviews: "Reviews", book: "Book", cta: "Free Quote" },
    hero: {
      badge: "Licensed & Insured Contractor · Winter Garden & Greater Orlando",
      l1: "Top-Rated Home Repairs",
      l2: "& Remodeling",
      l3: "Done Right, On Time.",
      sub: "From painting and drywall to full renovations. Get reliable, high-quality work with zero hidden fees and 100% satisfaction guaranteed.",
      cta1: "Get My Free Instant Quote",
      cta2: "Call (689) 246-5162",
      seals: ["Licensed & Insured", "4.9/5 Rating · 500+ Projects", "Fast 24-Hour Response"],
    },
    proof: [
      { n: "500+", l: "Projects completed" },
      { n: "100%", l: "Client satisfaction" },
      { n: "12+", l: "Years of experience" },
      { n: "4.9★", l: "Average rating" },
    ],
    marquee: "GUARANTEED WORK ✦ PREMIUM QUALITY ✦ FREE QUOTE ✦ FAST SERVICE ✦ LICENSED ✦",
    services: { overline: "What we do", title: "Services that build trust", cta: "Get a quote" },
    gallery: { overline: "Before & After", title: "Real Transformations in Orlando Homes", sub: "Drag to compare our recent work in Painting, Drywall, and Remodeling.", ctaText: "Like what you see?", ctaBtn: "Get a Similar Quote Today", filters: { all: "All", pintura: "Painting", reforma: "Remodel", drywall: "Drywall" }, before: "BEFORE", after: "AFTER" },
    why: {
      overline: "Why Seven Home",
      title: "Why Central Florida Homeowners Trust Seven Home Services",
      items: [
        { t: "Upfront & Transparent Pricing", d: "No surprise costs or hidden fees. What we quote is what you pay." },
        { t: "Licensed & Fully Insured", d: "Complete peace of mind knowing your property is 100% protected." },
        { t: "Fast & Reliable Scheduling", d: "We show up on time, respect your schedule, and finish on deadline." },
        { t: "Flawless Clean-Up", d: "We treat your home like our own. Zero mess left behind." },
      ],
    },
    midcta: { title: "Ready to transform your home?", sub: "Get your free quote now — limited spots this week.", cta1: "Get a quote", cta2: "Chat on WhatsApp" },
    guarantee: { overline: "Risk-free", title: "Our 100% Satisfaction Guarantee", body: "We don't consider the job complete until you are completely thrilled with the results. If something isn't right, we fix it immediately — no excuses." },
    reviews: { overline: "Social proof", title: "What our clients say" },
    form: {
      overline: "Free quote",
      title: "Request Your Free Estimate in 30 Seconds",
      urgency: "⚡ Limited schedule availability for this week.",
      name: "Full Name", phone: "Phone Number (Required)", email: "Email", zip: "Zip Code (To check service availability)", service: "Service Needed", selectService: "Service Needed", message: "Message (optional)",
      photo: "Attach a Photo of the Area (Optional — get a quote up to 2x faster)", uploading: "Uploading photo...", photoError: "Failed to upload photo.", remove: "Remove",
      submit: "GET MY FREE QUOTE NOW", sending: "Sending...",
      success: "We got your request! We'll contact you shortly.",
      error: "Oops, something went wrong. Try again or reach us on WhatsApp.",
      phoneReq: "Please provide a contact phone.",
    },
    book: {
      overline: "Online scheduling",
      title: "Book a free visit",
      date: "Date", time: "Time", selectTime: "Choose a time",
      submit: "Confirm booking", sending: "Booking...",
      success: "Visit booked! We'll confirm by phone.",
      step2Title: "Step 2 (optional): book your free visit",
      step2Sub: "Pick the best day and time for our team to visit.",
      skip: "Skip for now",
      thanksTitle: "All set! 🎉",
      thanksSub: "We got your details. Our team will reach out shortly.",
    },
    footer: { tagline: "Licensed and insured professionals.", quick: "Quick links", servicesTitle: "Services", contact: "Contact", rights: "All rights reserved." },
    chat: { title: "Chat with us", placeholder: "Type your message...", welcome: "Hi! 👋 How can we help with your home today?", send: "Send" },
    exit: { title: "Wait! 🎁", sub: "Don't leave without your free quote. Get 10% off booking this week.", cta: "Claim my discount", dismiss: "No, thanks" },
    mobile: { call: "Call", quote: "Quote" },
  },
};
